export default "__VITE_ASSET__BNs3M8GR__"